import { useNavigate } from 'react-router-dom';
import { Button, Field } from '@plush-book/ui';
import { StepHeader } from '../components/StepHeader';
import { useGeneratorStore } from '../state/generatorStore';

const OCCASIONS = ['Einschlafen', 'Geburtstag', 'Kita-Start', 'Weihnachten', 'Einfach so'];

export function PersonalDetails() {
  const nav = useNavigate();
  const { childName, dedication, fromWhom, occasion, setChildField } = useGeneratorStore();

  return (
    <div className="shell">
      <StepHeader active={2} />
      <div className="scroll" style={{ maxWidth: 760, margin: '0 auto', width: '100%' }}>
        <h2
          style={{
            fontFamily: 'var(--serif)',
            fontSize: 28,
            fontWeight: 500,
            margin: 0,
            letterSpacing: -0.3,
          }}
        >
          Noch ein paar Details
        </h2>
        <p style={{ fontSize: 14, color: 'var(--ink-soft)', marginTop: 6, marginBottom: 22 }}>
          Alle Felder optional — du kannst auch ohne weitermachen.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Field
            label="Name des Kindes"
            value={childName}
            onChange={(e) => setChildField('childName', e.target.value)}
            hint="Wird in der Geschichte und auf der Widmung verwendet."
          />
          <div>
            <label
              style={{
                fontSize: 12,
                color: 'var(--ink-soft)',
                fontWeight: 600,
                display: 'block',
                marginBottom: 6,
              }}
            >
              Widmung
            </label>
            <textarea
              value={dedication}
              onChange={(e) => setChildField('dedication', e.target.value)}
              placeholder="Für Carlo – weil Bruno jede Nacht auf dich aufpasst."
              style={{
                width: '100%',
                padding: '12px 14px',
                background: 'var(--bg-card)',
                border: '1px solid var(--line)',
                borderRadius: 12,
                fontSize: 14,
                fontFamily: 'var(--sans)',
                color: 'var(--ink)',
                resize: 'none',
                minHeight: 76,
                lineHeight: 1.45,
                boxSizing: 'border-box',
                outline: 'none',
              }}
            />
          </div>
          <Field
            label="Von wem ist das Buch?"
            value={fromWhom}
            onChange={(e) => setChildField('fromWhom', e.target.value)}
          />
          <div>
            <label
              style={{
                fontSize: 12,
                color: 'var(--ink-soft)',
                fontWeight: 600,
                display: 'block',
                marginBottom: 6,
              }}
            >
              Anlass
            </label>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {OCCASIONS.map((o) => (
                <button
                  key={o}
                  onClick={() => setChildField('occasion', o)}
                  style={{
                    padding: '8px 14px',
                    borderRadius: 999,
                    border:
                      occasion === o ? '1.5px solid var(--terracotta)' : '1px solid var(--line)',
                    background: occasion === o ? 'var(--bg-card)' : 'transparent',
                    fontSize: 12,
                    fontWeight: 600,
                    color: occasion === o ? 'var(--terracotta-deep)' : 'var(--ink-soft)',
                    cursor: 'pointer',
                  }}
                >
                  {o}
                </button>
              ))}
            </div>
          </div>
        </div>

        {(dedication || fromWhom) && (
          <div
            style={{
              marginTop: 22,
              padding: 18,
              background: 'var(--bg-card)',
              border: '1px solid var(--line)',
              borderRadius: 16,
            }}
          >
            <div
              style={{
                fontSize: 10,
                color: 'var(--ink-mute)',
                letterSpacing: 1.5,
                fontFamily: 'var(--mono)',
                marginBottom: 12,
              }}
            >
              VORSCHAU WIDMUNG
            </div>
            <div
              style={{
                aspectRatio: '3/4',
                maxWidth: 220,
                margin: '0 auto',
                background: 'var(--bg)',
                border: '1px solid var(--line)',
                borderRadius: 4,
                padding: 24,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
                boxShadow: '0 4px 12px -6px rgba(0,0,0,0.15)',
              }}
            >
              <div
                style={{
                  fontFamily: 'var(--serif)',
                  fontSize: 14,
                  fontStyle: 'italic',
                  color: 'var(--ink-soft)',
                  lineHeight: 1.5,
                }}
              >
                {dedication ||
                  (childName ? `Für ${childName}.` : 'Für dich.')}
              </div>
              {fromWhom && (
                <>
                  <div
                    style={{
                      width: 24,
                      height: 1,
                      background: 'var(--ink-mute)',
                      margin: '12px auto',
                    }}
                  />
                  <div style={{ fontSize: 12, color: 'var(--ink-mute)' }}>{fromWhom}</div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="sticky-cta" style={{ maxWidth: 760, margin: '0 auto', width: '100%' }}>
        <Button variant="dark" size="md" fullWidth onClick={() => nav('/loading')}>
          Vorschau erstellen →
        </Button>
      </div>
    </div>
  );
}
